
import '../Stylesheets/Main.css';
import { useState, useEffect } from 'react';
import axios from 'axios';

import Header from './Header/Header';

const HOST = "https://guidos-fahrradwelt.de";

function NewsList() {


    const apiAddress = `${HOST}/api/news-fetch.php`

    const [newsData, setNewsData] = useState([]);

    const getData=()=>{
      
      axios
      .get(apiAddress)
      .then((res) => {
        setNewsData(res.data);
      }).catch((error) => {
        console.error("Error fetching News:", error);
      });
      }

    useEffect(()=>{
      getData()
      },[])

    return(
      <div className='news-list'>
        {newsData.map(item => (
        <article className='news-article' key={item.id}>
            <img src={`${HOST}/${item.img_path}`} alt="News Thumbnail" className="news-image" />
            <div className="news-text-wrapper">
                <h3 className="news-list-title">
                    {item.title}
                </h3>
                <p className="news-list-text">
                    {item.text}
                </p>
                <p className='news-date'>
                    {item.date}
                </p>
            </div>
        </article>
        ))}
      </div>
      );
  }

export default NewsList;
